
import {Options, Vue} from "vue-class-component";
import {AppointmentDto} from "@/types/appointments";
import ModuleAppointments from "@/store/appointments";
import {getRowColor, getPaymentStatusColor, getAppointmentStatusColor} from "@/utils/color-utils";
import {format} from "date-fns";
import {getPaymentStatusIcon} from "@/utils/paymentStatusIcon-utils";

@Options({
})
export default class Appointments extends Vue{
    private allAppointments: AppointmentDto[] = []
    private isCalendarView: boolean = true;
    private groupBy: any = [
        {
            key: 'appointmentDate',
            order: 'asc',
        },
    ];
    private headers: any = [
        { title: 'Client name', key: 'clientName' },
        { title: 'Start', key: 'slot' },
        { title: 'End', key: 'endTime' },
        { title: 'Appointment status', key: 'status', filter: value => {
            if (!this.appointmentStatus) return true;
            return value === this.appointmentStatus
            } },
        { title: 'Payment status', key: 'paymentStatus', filter: value => {
            if (!this.paymentStatus) return true;
            return value === this.paymentStatus
            } },
        { title: 'Action', key: '' },
        { title: '', key: 'appointmentDate', filter: value => {
            return !(!this.showPreviousAppointments && value.localeCompare(format(new Date(), "yyyy-MM-dd")) < 0 );

            } },
        { title: 'Rating', key: 'rating' },
    ];
    private dialog: boolean = false;
    private filtersDialog: boolean = false;
    private weekday: number[] = [1, 2, 3, 4, 5, 6, 0];
    private showPreviousAppointments: boolean = false;
    private events: any = [];
    private type: string = 'month';
    private types: string[] = ['month', 'week', 'day'];
    private value: Date[] = [];
    private weekdays: any = [
        { title: 'Sun - Sat', value: [0, 1, 2, 3, 4, 5, 6] },
        { title: 'Mon - Sun', value: [1, 2, 3, 4, 5, 6, 0] },
        { title: 'Mon - Fri', value: [1, 2, 3, 4, 5] },
        { title: 'Mon, Wed, Fri', value: [1, 3, 5] },
    ];
    private appointmentStatuses: any = [
        { title: "REQUESTED", value: "REQUESTED" },
        { title: "SCHEDULED", value: "SCHEDULED" },
        { title: "RESCHEDULED", value: "RESCHEDULED" },
        { title: "COMPLETED", value: "COMPLETED" },
        { title: "MISSED", value: "MISSED" },
        { title: "CANCELLED", value: "CANCELLED" }
    ]
    private appointmentStatus: string = "";
    private paymentStatuses: any = [
        { title: "PAYMENT_REQUESTED", value: "PAYMENT_REQUESTED" },
        { title: "PAID", value: "PAID" },
        { title: "REFUNDED", value: "REFUNDED" },
        { title: "CANCELLED", value: "CANCELLED" },
        { title: "FAILED", value: "FAILED" },
        { title: "FREE", value: "FREE" },
        { title: "UNKNOWN", value: "UNKNOWN" },
    ]
    private paymentStatus: string = "";
    private search: string = "";
    private loading: boolean = false;
    private isExpandAppointments: boolean = true;

    async mounted() {
        this.allAppointments = (await ModuleAppointments.getAllAppointments())
        this.getEvents(this.allAppointments);
    }

    getEvents (appointments: AppointmentDto[]) {
        this.events = appointments.filter(appointment => appointment.status !== "CANCELLED").map((appointment: AppointmentDto) => ({
            title: appointment.clientName,
            start: appointment.start,
            end: appointment.end,
            color: appointment.color,
            slot: appointment.slot,
            showMenu: false,
            allDay: false,
            duration: appointment.slot + " - " + appointment.endTime,
            userId: appointment.userId,
            paymentStatus: appointment.paymentStatus
        }))
    }

    getRowColor(appointment: AppointmentDto): string {
        return getRowColor(appointment);
    }

    getPaymentStatusColor(paymentStatus: string): string {
        return getPaymentStatusColor(paymentStatus);
    }

    getAppointmentStatusColor(appointmentStatus: string): string {
        return getAppointmentStatusColor(appointmentStatus);
    }

    onClearFilters() {
        this.search = '';
        this.showPreviousAppointments = false;
        this.appointmentStatus = "";
        this.paymentStatus = "";
    }

    async onUpdate(appointment: AppointmentDto) {
        this.loading = true;
        try {
            let updatedAppointment = await ModuleAppointments.updateAppointment(appointment);
            let foundIndex = this.allAppointments.findIndex((value, index, obj) => {
                return value.appointmentId === updatedAppointment.appointmentId
            })

            if (foundIndex !== -1) {
                this.allAppointments[foundIndex] = updatedAppointment
            }

            const notification = (this[`$notify`] as any).success(
                "Saved successfully"
            )

            setTimeout(() => {
                notification.close();
            }, 3000);
        }
        catch (error) {
            const notification = (this[`$notify`] as any).error(
                "Failed to save"
            )

            setTimeout(() => {
                notification.close();
            }, 3000);
        }
        finally {
            this.loading = false;
        }
    }

    getPaymentStatusIcon(paymentStatus: string): string {
        return getPaymentStatusIcon(paymentStatus);
    }
}
